import stratifyVar from '../refs/stratifyVar';

const calculateCorrelation = require("calculate-correlation")

var pcorrtest = require( '@stdlib/stats-pcorrtest' );
const jstat = require('jstat');


export default function pfscurveplot({
    divId,
    varName,
    threshold,
    pfsData,
    varOmics,
    varType,
    trackDetails,
    cohortSelected,
    studySelected,
    overallCurve
    // trackA,
    // trackB,
    // useZscore,
}) {
    const divCurrentWidth = document.getElementById(divId).offsetWidth

    const Plotly = window.Plotly
    console.log('pfscurveplot.js pfsData', pfsData)
    if (!pfsData) { return }
    console.log('pfscurveplot.js pfsData not null', pfsData)
    let kmf = new KaplanMeierFitter();

    let plotVariable = ''
    if (varType === 'Genes') {
        // if (varOmics === 'RNA') {
        // }
        if (varOmics.includes(' ')) {
            plotVariable = `${varName}_${varOmics}`
        } else {
            plotVariable = `${varName} ${varOmics}`
        }
    } else {
        plotVariable = varName
    }
    console.log('pfscurveplot.js plotVariable', plotVariable)

    // let plotVariable = varType === 'Genes' ? `${varName} ${varOmics}` : varName;
    console.log('pfscurveplot.js plotVariable', plotVariable)
    let daysKeyName = ''
    let eventKeyName = ''
    let overallBool = overallCurve && studySelected === "PCC"
    let xaxis_title = ''
    let title_prefix = ''
    if (overallBool) {
        daysKeyName = 'overallSurvivalDaysKey'
        eventKeyName = 'overallSurvivalEventsKey'
        xaxis_title = 'Overall Survival Days'
        title_prefix = 'Overall Survival Curve'
    } else {
        daysKeyName = 'pfsDaysKey'
        eventKeyName = 'pfsEventKey'
        xaxis_title = 'Progression-free Survival Days'
        title_prefix = 'PFS Curve'
    }
    let pfsDaysKey_ = stratifyVar[studySelected][daysKeyName];
    // let pfsDaysKey_ = 'PFS_days_clipped2000';
    let pfsEventKey_ = stratifyVar[studySelected][eventKeyName][0];

    let eventYesKey_ = stratifyVar[studySelected][eventKeyName][1];
    let eventNoKey_ = stratifyVar[studySelected][eventKeyName][2];
    console.log('pfscurveplot.js pfsData check', pfsData[pfsDaysKey_])
    let pfsDaysIDs = Object.keys(pfsData[pfsDaysKey_].data).filter(s => Object.keys(pfsData[pfsEventKey_][s] !== null));
    let pfsEventIDs = Object.keys(pfsData[pfsEventKey_].data).filter(s => Object.keys(pfsData[pfsEventKey_][s] !== null));

    let pValue = '';
    let tracesList = [];
    console.log('pfscurveplot.js trackDetails', trackDetails)
    let intersectionIDs_ = pfsDaysIDs.filter(x => pfsEventIDs.includes(x));
    let intersectionIDs = intersectionIDs_.filter(x => cohortSelected.includes(pfsData.cohort.data[x]))
    
    let title_cohort_text = 'both discovery and validation cohorts'
    if (cohortSelected.length < 2) {
        title_cohort_text = `the ${cohortSelected[0]} cohort`
    }
    // let valuesOfVarName = new Set(pfsData[varName].map(d => d[key]));
    // let varNameValue = [];
    // TODO: check if varName is categorical

    // get the values set by varName

    let legend_cohort_text = 'all cohorts'
    if (cohortSelected.length < 2) {
        legend_cohort_text = `${cohortSelected[0]} cohort`
    }
    var listForPValues = []
    var nanCatCount = 0
    if (varName in trackDetails) {
        console.log('pfscurveplot.js plotVariable in trackDetails', plotVariable)
        
        trackDetails[plotVariable].forEach((category) => {   
            const categoryLabel = category.label;
            const categoryValue = category.value;
            const categoryColor = category.color;
            if (categoryValue === "NaN" || categoryValue === null) {
                nanCatCount += 1
                return;
            }
            console.log('pfscurveplot.js categoryLabel', categoryLabel)
            console.log('pfscurveplot.js categoryValue', categoryValue)
            console.log('pfscurveplot.js categoryColor', categoryColor)

            let intersectionIDsByCat = intersectionIDs.filter(id => pfsData[plotVariable].data[id] === categoryLabel);
            // let pfsEventIDsFiltered = pfsEventIDs.filter(id => pfsData[plotVariable].data[id] === categoryValue);

            console.log('pfscurveplot.js intersectionIDsByCat', intersectionIDsByCat)
            // console.log('pfscurveplot.js pfsEventIDsFiltered', pfsEventIDsFiltered)

            // if (pfsDaysIDsFiltered.length > 0 && pfsEventIDsFiltered.length > 0) {
                // let intersectionIDs = pfsDaysIDsFiltered.filter(x => pfsEventIDsFiltered.includes(x));
            // console.log('pfscurveplot.js intersectionIDs', intersectionIDs)
            let pfsDataFiltered = intersectionIDsByCat.map(id => {
                let returnSet = new Set();
                returnSet[pfsDaysKey_] = pfsData[pfsDaysKey_].data[id];
                returnSet[pfsEventKey_] = pfsData[pfsEventKey_].data[id];
                return returnSet;
            });
            console.log('pfscurveplot.js pfsDataFiltered', category, pfsDataFiltered)
            // let pfsDataArray = []
            var pfsCurveData = kmf.fit(pfsDataFiltered, pfsDaysKey_, pfsEventKey_, 
                                        eventYesKey_, eventNoKey_);
            console.log('pfscurveplot.js pfsCurveData', category, pfsCurveData)
            var pfsCurveTraces = plotKaplanMeier(pfsCurveData, `${categoryLabel}<br>(N=${intersectionIDsByCat.length})`, categoryColor,
                                                    // eventYesKey_, eventNoKey_
                                                );

            tracesList = tracesList.concat(pfsCurveTraces['traces']);
            
            listForPValues.push(pfsDataFiltered)
            // }
        })
        console.log('pfscurveplot.js trackDetails[plotVariable].length', trackDetails[plotVariable].length)
        if ((trackDetails[plotVariable].length - nanCatCount) == 2) {
            let chiSqStats = logRankTest(listForPValues[0], listForPValues[1], pfsDaysKey_, pfsEventKey_,
                 eventYesKey_, eventNoKey_
            )
            // let df = 1; // Degrees of freedom for comparing two groups
            // Calculate p-value
            // pValue = 1 - jstat.gamma.cdf(chiSqStats / 2, df / 2, 1);
            pValue = chiSqStats.pValue.toExponential(2).toString()
        }
    
    } else {
        // If plotVariable is not in trackDetails, we assume it's a continuous variable
        // get median of values of plotVariable
        // let valuesOfVarName = Object.values(pfsData[plotVariable].data).filter(item => item !== null && item !== undefined)
        
        console.log('pfscurveplot.js plotVariable', plotVariable, pfsData)
        let valuesOfVarName = Object.entries(
                                    pfsData[plotVariable].data).filter(
                                        ([key, item]) => (item !== null && item !== undefined) && intersectionIDs.includes(key)
                                    ).map(([key, value]) => value);
        console.log('pfscurveplot.js valuesOfVarName', valuesOfVarName)
        
        let sortedValues = valuesOfVarName.sort((a, b) => a - b)
        let medianValue = valuesOfVarName.sort((a, b) => a - b)[Math.floor(valuesOfVarName.length / 2)];
        // strainify data by median value
        let thresholdValue = sortedValues[Math.floor(sortedValues.length * threshold/100)];
        let intersectionIDsBelowMedian = intersectionIDs.filter(id => pfsData[plotVariable].data[id] < thresholdValue);
        let intersectionIDsAboveMedian = intersectionIDs.filter(id => pfsData[plotVariable].data[id] >= thresholdValue);
        
        let varGroups = new Set()
        let legendPrefix = varOmics === 'RNA' ? 'expression' : 'abundance';
        console.log('pfscurveplot.js thresholdValue', thresholdValue)
        varGroups[`High ${legendPrefix} (>=${thresholdValue.toFixed(3)})`] = {data: intersectionIDsAboveMedian, 
                                                        color: '#1f77b4'}; // blue
        varGroups[`Low ${legendPrefix} (<${thresholdValue.toFixed(3)})`] = {data: intersectionIDsBelowMedian,
                                                        color: '#ff7f0e'}; // orange
        // colorList = ['#1f77b4', '#ff7f0e']; // blue and orange
        Object.entries(varGroups).forEach(([group_, grouped_data]) => {
            if (grouped_data.data.length > 0) {
                let pfsDataFiltered = grouped_data.data.map(id => {
                    let returnSet = new Set();
                    returnSet[pfsDaysKey_] = pfsData[pfsDaysKey_].data[id];
                    returnSet[pfsEventKey_] = pfsData[pfsEventKey_].data[id];
                    return returnSet;
                });
                console.log('pfscurveplot.js pfsDataFiltered', pfsDataFiltered)
                // let pfsDataArray = []
                
                var pfsCurveData = kmf.fit(pfsDataFiltered, pfsDaysKey_, pfsEventKey_, eventYesKey_, eventNoKey_);
                console.log('pfscurveplot.js pfsCurveData', group_, pfsCurveData)
                var pfsCurveTraces = plotKaplanMeier(pfsCurveData, `${group_}<br>(N=${grouped_data.data.length})`, grouped_data.color,
                                                        // eventYesKey_, eventNoKey_
                                                    );
                tracesList = tracesList.concat(pfsCurveTraces['traces']);
                // var listForPValues = [];
                listForPValues.push(pfsDataFiltered)
            }
        })
        let chiSqStats = logRankTest(listForPValues[0], listForPValues[1], pfsDaysKey_, pfsEventKey_,
             eventYesKey_, eventNoKey_
        )
        // console.log('pfscurveplot.js chiSqStats', chiSqStats)
        // let df = 1; // Degrees of freedom for comparing two groups
        // // Calculate p-value
        // pValue = 1 - jstat.gamma.cdf(chiSqStats / 2, df / 2, 1);
        pValue = chiSqStats.pValue.toExponential(2).toString()
    }
    
    // Whole cohort PFS curve

    console.log('pfscurveplot.js intersectionIDs', intersectionIDs)
    let pfsDataFiltered = intersectionIDs.map(id => {
        let returnSet = new Set();
        returnSet[pfsDaysKey_] = pfsData[pfsDaysKey_].data[id];
        returnSet[pfsEventKey_] = pfsData[pfsEventKey_].data[id];
        return returnSet;
    });
    console.log('pfscurveplot.js pfsDataFiltered', pfsDataFiltered)
    // let pfsDataArray = []
    var pfsCurveData = kmf.fit(pfsDataFiltered, pfsDaysKey_, pfsEventKey_, eventYesKey_, eventNoKey_);
    console.log('pfscurveplot.js pfsCurveData', 'all', pfsCurveData)

    var pfsCurveTraces = plotKaplanMeier(pfsCurveData, `Whole Cohort<br>(N=${intersectionIDs.length})`, '#D3D3D3', 'dashdot',
                                            // eventYesKey_, eventNoKey_
                                        ); // green
    tracesList = tracesList.concat(pfsCurveTraces['traces']);
        
    
    let plotTitle = varType === 'Genes' ? `${varName}` : `${varName} ${varOmics}`;
    let pValueText = ''
    if (pValue !== '') {
        pValueText = `<br>log-rank P-value: ${pValue}`
    }
    console.log('pfscurveplot.js pValueText', pValueText)
    var layout = {
        // title: `${trackA.title} - ${trackB.title}<br>pearson correlation: ${correlation}`,
        title: { text: `${title_prefix} stratified by ${plotVariable}<br>(${title_cohort_text})${pValueText}`},
        xaxis: {
            title: { text: xaxis_title, 
                    font: { size: 18 }
                    },
            hoverformat: '.2f',
            range: [0, 2000],
            
            // scaleanchor: "y",
            // scaleratio: 1,
        },
        yaxis: {
            title: { text: 'Survival Probability',
                    font: {
                            size: 18
                        }
                    },
            hoverformat: '.2f',
            // scaleanchor: "x",
            // scaleratio: 1,
        },
        scene: {
            aspectratio: {
            x: 1,
            y: 10,
            z: 1
            }
        },
        width: divCurrentWidth,
        height: divCurrentWidth*0.8,
        legend: {
            font: {
                size: 18}
        }
    };
      
    Plotly.newPlot(divId, tracesList, layout);
}

function intersect(o1, o2){
    return Object.keys(o1).filter(k => Object.hasOwn(o2, k))
}

function linearRegression(x,y){
    var lr = {};
    var n = y.length;
    var sum_x = 0;
    var sum_y = 0;
    var sum_xy = 0;
    var sum_xx = 0;
    var sum_yy = 0;

    for (var i = 0; i < y.length; i++) {

        sum_x += x[i];
        sum_y += y[i];
        sum_xy += (x[i]*y[i]);
        sum_xx += (x[i]*x[i]);
        sum_yy += (y[i]*y[i]);
    } 

    lr['sl'] = (n * sum_xy - sum_x * sum_y) / (n*sum_xx - sum_x * sum_x);
    lr['off'] = (sum_y - lr.sl * sum_x)/n;
    lr['r2'] = Math.pow((n*sum_xy - sum_x*sum_y)/Math.sqrt((n*sum_xx-sum_x*sum_x)*(n*sum_yy-sum_y*sum_y)),2);

    return lr;
}

class KaplanMeierFitter {
    fit(data, pfsDaysKey, pfsEventKey, eventYesKey, eventNoKey) {
      // Sort data by time
      data.sort((a, b) => a[pfsDaysKey] - b[pfsDaysKey]);
  
      let kmEstimates = [];
      let atRisk = data.length;
      let survivalProbability = 1.0;
      console.log('KaplanMeierFitter.js atRisk', atRisk)
  
      for (let i = 0; i < data.length; i++) {
        // let eventCount = data.filter(d => d[pfsDaysKey] === data[i][pfsDaysKey] && (d[pfsEventKey]==='Y')).length;
        // let censorCount = data.filter(d => d[pfsDaysKey] === data[i][pfsDaysKey] && (d[pfsEventKey]==='N')).length;
  
        // if (eventCount > 0) {
        //   survivalProbability *= (1 - eventCount / atRisk);
        // }
  
        // kmEstimates.push({
        //   time: data[i][pfsDaysKey],
        //   survivalProbability: survivalProbability,
        //   atRisk: atRisk,
        //   eventCount: eventCount,
        //   censorCount: censorCount
        // });
  
        // atRisk -= (eventCount + censorCount);
        if (data[i][pfsEventKey] === eventYesKey) {
            // const survivalProbability = ;
            survivalProbability *= ((atRisk - 1) / atRisk);
            kmEstimates.push({
                time: data[i][pfsDaysKey],
                survivalProbability,
            });
        } else {
            kmEstimates.push({
                time: data[i][pfsDaysKey],
                survivalProbability,
            });
        }
        atRisk--;

      }
  
        return kmEstimates;
    }
}

function kmEstimator(data, pfsDaysKey, pfsEventKey) {
  // Combine event times and observed events into a single array
//   const data = eventTimes.map((time, index) => ({
//     time,
//     observed: eventObserved[index],
//   }));

  // Sort data by event time
  data.sort((a, b) => a[pfsDaysKey] - b[pfsDaysKey]);
  // Calculate number at risk and number of events

  let nAtRisk = data.length;
  let nEvents = 0;
  const survivalProbabilities = [];

  let cumulativeSurvivalProbability = 1;
  for (let i = 0; i < data.length; i++) {
    if (data[i][pfsEventKey] === 'Y') {
      nEvents++;
      const survivalProbability = (nAtRisk - 1) / nAtRisk;
      cumulativeSurvivalProbability *= survivalProbability;
      survivalProbabilities.push({
        time: data[i][pfsDaysKey],
        cumulativeSurvivalProbability,
      });
      nAtRisk--;
    } else {
      survivalProbabilities.push({
        time: data[i][pfsDaysKey],
        cumulativeSurvivalProbability,
      });
      nAtRisk--;
    }
  }

  return survivalProbabilities;
}

function plotKaplanMeier(kmEstimates, traceName = '', traceColor = '#1f77b4', lineStyle = 'solid') {
    let x = kmEstimates.map(d => d.time);
    let y = kmEstimates.map(d => d.survivalProbability);
    // let censored = kmEstimates.map(d => d.censorCount > 0 ? d.survivalProbability : null);
    let lineName = traceName === '' ? 'Survival Probability' : `${traceName}`;
    // if (traceName === '') {
// 
    let trace1 = {
        x: x,
        y: y,
        mode: 'lines',
        type: 'scatter',
        name: lineName,
        line: { color: traceColor, dash: lineStyle , shape: 'hv'},
    };

    // let censored = kmEstimates.map(d => d.censorCount > 0 ? d.survivalProbability : null);
    // let trace2 = {
    //     x: kmEstimates.filter(d => d.censorCount > 0).map(d => d.time),
    //     y: censored.filter(d => d !== null),
    //     mode: 'markers',
    //     marker: { symbol: 'x', size: 10 },
    //     type: 'scatter',
    //     name: 'Censored'
    // };

    let layout = {
        title: 'Kaplan-Meier Curve',
        xaxis: { title: 'Progression-Free Survival Days' },
        yaxis: { title: 'Survival Probability', range: [0, 1] }
    };
    return { traces: [trace1], layout: layout };
// Plotly.newPlot('myDiv', [trace1, trace2], layout);
}

// function logRankTest(group1, group2, timeKey, eventKey) {
//     // Assuming group1 and group2 are arrays of objects with 'time' and 'event' properties
//     // 'time' is the survival time, 'event' is a boolean indicating whether the event occurred (true) or was censored (false)
  
//     let observedEventsGroup1 = 0;
//     let observedEventsGroup2 = 0;
//     let expectedEventsGroup1 = 0;
//     let expectedEventsGroup2 = 0;
//     let variance = 0;
  
//     // Combine and sort events
//     let events = [...group1.map(e => ({...e, group: 1})), ...group2.map(e => ({...e, group: 2}))].sort((a, b) => a[timeKey] - b[timeKey]);
  
//     let atRiskGroup1 = group1.length;
//     let atRiskGroup2 = group2.length;
//     console.log('logRankTest.js events', events)
//     console.log('logRankTest.js atRiskGroup1', atRiskGroup1)
//     console.log('logRankTest.js atRiskGroup2', atRiskGroup2)
//     for (let event of events) {
//       // Calculate expected events and update at-risk counts
//       if (event[eventKey] === 'Y') {
//         if (event.group === 1) {
//           observedEventsGroup1++;
//           expectedEventsGroup1 += atRiskGroup1 / (atRiskGroup1 + atRiskGroup2);
//           expectedEventsGroup2 += atRiskGroup2 / (atRiskGroup1 + atRiskGroup2);
//         } else {
//           observedEventsGroup2++;
//           expectedEventsGroup1 += atRiskGroup1 / (atRiskGroup1 + atRiskGroup2);
//           expectedEventsGroup2 += atRiskGroup2 / (atRiskGroup1 + atRiskGroup2);
//         }
//       }
//       // Update at-risk counts
//       if (event.group === 1) atRiskGroup1--;
//       else atRiskGroup2--;
//     }
//     console.log('logRankTest.js observedEventsGroup1', observedEventsGroup1)
//     console.log('logRankTest.js observedEventsGroup2', observedEventsGroup2)
//     console.log('logRankTest.js expectedEventsGroup1', expectedEventsGroup1)
//     console.log('logRankTest.js expectedEventsGroup2', expectedEventsGroup2)
//     // Calculate variance and the logrank statistic
//     variance = observedEventsGroup1 + observedEventsGroup2 - expectedEventsGroup1 - expectedEventsGroup2;
//     let logRankStatistic = Math.pow(observedEventsGroup1 - expectedEventsGroup1, 2) / variance;
  
//     // Chi-square distribution with 1 degree of freedom for p-value calculation
//     // You'd typically use a chi-square distribution function from a library here
  
//     return { logRankStatistic };
//     // Return or calculate p-value based on the chi-square distribution
//   }

function chi2pvalue(chi2) {
    let df = 1; // Degrees of freedom for comparing two groups
  return 1 - jstat.gamma.cdf(chi2 / 2, df / 2, 1);
}

function logRankTest(group1, group2, timeKey, eventKey, eventYesKey, eventNoKey) {
  const allTimes = [...new Set([...group1.map(d => d[timeKey]), ...group2.map(d => d[timeKey])])].sort((a, b) => a - b);
  console.log('logRankTest.js allTimes', allTimes)

  const eventTimes = allTimes.filter(time =>
    group1.some(d => d[timeKey] === time && d[eventKey] === eventYesKey) ||
    group2.some(d => d[timeKey] === time && d[eventKey] === eventYesKey)
  );

  let observed1 = 0;
  let expected1 = 0;
  let variance = 0;

  for (const time of eventTimes) {
    const atRisk1 = group1.filter(d => d[timeKey] >= time).length;
    const atRisk2 = group2.filter(d => d[timeKey] >= time).length;
    const totalAtRisk = atRisk1 + atRisk2;

    const events1 = group1.filter(d => d[timeKey] === time && d[eventKey] === eventYesKey).length;
    const events2 = group2.filter(d => d[timeKey] === time && d[eventKey] === eventYesKey).length;
    const totalEvents = events1 + events2;

    observed1 += events1;
    const expected_i = totalEvents * (atRisk1 / totalAtRisk);
    expected1 += expected_i;

    if (totalAtRisk > 1) {
      variance += (totalEvents * atRisk1 * atRisk2 * (totalAtRisk - totalEvents)) /
                  (totalAtRisk * totalAtRisk * (totalAtRisk - 1));
    }
  }

  const logRankStatistic = ((observed1 - expected1) * (observed1 - expected1)) / variance;
  console.log('logRankTest.js logRankStatistic', logRankStatistic)
  const pValue = chi2pvalue(logRankStatistic);
  console.log('logRankTest.js pValue', pValue)
  return { logRankStatistic, pValue };
}

function create_fitted_line_trace(_x, _y, _color, _des) {
    var fit_from = Math.min(..._x)
    var fit_to = Math.max(..._x)
    var lr = linearRegression(_x, _y);
    var fit = {
        x: [fit_from, fit_to],
        y: [fit_from*lr.sl+lr.off, fit_to*lr.sl+lr.off],
        mode: 'lines',
        type: 'scatter',
        line: {color: _color},
        name: _des
        // name: "R2=".concat((Math.round(lr.r2 * 10000) / 10000).toString())
        };
    return fit
}

function filter_non_nan_xy(_x, _y){
    var non_na_xidx = _x.map(i => i !== undefined)
    var non_na_yidx = _y.map(i => i !== undefined)

    var non_na_xyidx = non_na_xidx.map((e, i) => e & non_na_yidx[i])
    var _non_na_x = _x.filter((e, i) => non_na_xyidx[i])
    var _non_na_y = _y.filter((e, i) => non_na_xyidx[i])
    var non_nan_xy = {};
    non_nan_xy['x'] = _non_na_x
    non_nan_xy['y'] = _non_na_y
    return non_nan_xy
}

function track_to_lines(xTrack, yTrack) {
    const samples_ = Object.keys(yTrack.data).filter(s => Object.keys(xTrack.data).includes(s))

    const x_ = samples_.map(sample => xTrack.data[sample])
    const y_ = samples_.map(sample => yTrack.data[sample])

    // console.log('test scatter 7')
    // console.log(samples)
    // console.log(trackA)
    var non_nan_xy_ = filter_non_nan_xy(x_, y_)
    var non_na_x_ = non_nan_xy_.x
    var non_na_y_ = non_nan_xy_.y
    // console.log(non_na_x_)
    // console.log(non_na_y_)
    var corr_dict = pcorrtest(non_na_x_, non_na_y_)
    var correlation = corr_dict.pcorr
    var corr_pv = corr_dict.pValue
    console.log(non_na_x_)
    console.log(non_na_y_)
    var return_data_dict = {'non_na_x': non_na_x_, 
                            'non_na_y': non_na_y_, 
                            'x':    x_, 
                            'y':    y_, 
                            'corr': correlation.toFixed(3),
                            'pv': corr_pv.toPrecision(3).replace(/e\+?/, ' x 10^')
                        }
    return return_data_dict
}